import "core-js/modules/es6.function.name";

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from "react";
import { navigate } from "gatsby-link";
import axios from "axios";
import Layout from "../../components/layout";
import SEO from "../../components/seo";
import SocialConnect from "../../components/SocialConnect";

var Contact =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Contact, _React$Component);

  function Contact(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.handleChange = function (e) {
      var _this$setState;

      _this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value, _this$setState));
    };

    _this.handleSubmit = function (e) {
      e.preventDefault();
      var form = e.target;
      axios.post("https://formcarry.com/s/ETtOHVN8A5-", _this.state, {
        headers: {
          "Accept": "application/json"
        }
      }).then(function () {
        return navigate(form.getAttribute("action"));
      }).catch(function (error) {
        return alert(error);
      });
    };

    _this.state = {
      isValidated: false
    };
    return _this;
  }

  var _proto = Contact.prototype;

  _proto.render = function render() {
    return React.createElement(Layout, null, React.createElement(SEO, {
      title: "Contact"
    }), React.createElement("div", {
      className: "container",
      style: {
        marginTop: "2rem"
      }
    }, React.createElement("h2", null, "Contact", React.createElement("span", {
      className: "accent"
    }, ".")), React.createElement("p", null, "Wanna talk? Send me an email through the form below or get in touch through my social media."), React.createElement("form", {
      name: "contact",
      method: "POST",
      action: "/contact/thanks/",
      "data-netlify": "true",
      "data-netlify-honeypot": "bot-field",
      onSubmit: this.handleSubmit
    }, React.createElement("input", {
      type: "hidden",
      name: "form-name",
      value: "contact"
    }), React.createElement("input", {
      type: "hidden",
      name: "bot-field",
      onChange: this.handleChange
    }), React.createElement("div", {
      className: "field"
    }, React.createElement("label", {
      htmlFor: "name"
    }, "Name ", React.createElement("span", {
      className: "accent"
    }, "*")), React.createElement("input", {
      className: "input",
      type: "text",
      name: "name",
      onChange: this.handleChange,
      id: "name",
      required: true
    })), React.createElement("div", {
      className: "field"
    }, React.createElement("label", {
      htmlFor: "email"
    }, "Email ", React.createElement("span", {
      className: "accent"
    }, "*")), React.createElement("input", {
      className: "input",
      type: "email",
      name: "email",
      onChange: this.handleChange,
      id: "email",
      required: true
    })), React.createElement("div", {
      className: "field"
    }, React.createElement("label", {
      htmlFor: "message"
    }, "Message ", React.createElement("span", {
      className: "accent"
    }, "*")), React.createElement("textarea", {
      className: "textarea",
      name: "message",
      onChange: this.handleChange,
      id: "message",
      required: true
    })), React.createElement("div", {
      className: "actions"
    }, React.createElement("button", {
      type: "submit",
      className: "special"
    }, "Send message \xBB"))), React.createElement(SocialConnect, null)));
  };

  return Contact;
}(React.Component);

export default Contact;